"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCookie = exports.checkAndDeleteCookie = exports.clearCookies = exports.setCookieItem = exports.getCookieItem = void 0;

var react_1 = require("react"); //list of ryerson only cookies


var cookiesToDelete = [".serial_number", ".ASPXAUTH", ".AspNet.ApplicationCookie", "UnregisterdUser", "parametric", "FixedSiteCoreKey", "RyersonDirect.Models.Cookies.*"];

var getCookieItem = function getCookieItem(key) {
  if (typeof document !== "undefined") {
    return document === null || document === void 0 ? void 0 : document.cookie.split("; ").reduce(function (total, currentCookie) {
      var item = currentCookie.split("=");
      var storedKey = item[0];
      var storedValue = item[1];
      return key === storedKey ? decodeURIComponent(storedValue) : total;
    }, "");
  } else {
    return JSON.stringify("");
  }
};

exports.getCookieItem = getCookieItem;

var setCookieItem = function setCookieItem(key, value, numberOfDays) {
  var currentDateTime = new Date();
  currentDateTime.setTime(currentDateTime.getTime() + numberOfDays * 60 * 60 * 24 * 1000); // Can't use document?.cookies because it is at left hand side of assignment operator

  if (typeof document !== "undefined") {
    document.cookie = "".concat(key, "=").concat(value, "; expires=").concat(currentDateTime.toUTCString(), "; path=/");
  }
};

exports.setCookieItem = setCookieItem;

var clearCookies = function clearCookies() {
  if (typeof document === "undefined") return;
  cookiesToDelete.forEach(function (cookie) {
    (0, exports.checkAndDeleteCookie)(cookie);
  });
};

exports.clearCookies = clearCookies;

var checkAndDeleteCookie = function checkAndDeleteCookie(cookieName) {
  // Split the cookies into an array
  var cookies = document.cookie.split("; "); // Iterate through the cookies to find the one you want

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].split("="); //Intentionally added console for debugging will be removed later

    /*eslint-disable no-console*/

    console.log(cookie); // Trim leading and trailing spaces

    var name = cookie[0].replace(/^\s+|\s+$/g, ""); // Check if the current cookie matches the target cookie

    if (name === cookieName) {
      // Set the expiration date in the past to delete the cookie
      document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
      return;
    }
  }
};

exports.checkAndDeleteCookie = checkAndDeleteCookie;

var useCookie = function useCookie(key, defaultValue) {
  var getCookie = function getCookie() {
    return JSON.parse((0, exports.getCookieItem)(key) || JSON.stringify(defaultValue));
  };

  var _ref = (0, react_1.useState)(getCookie()),
      _ref2 = _slicedToArray(_ref, 2),
      cookie = _ref2[0],
      setCookie = _ref2[1];

  var updateCookie = function updateCookie(value, numberOfDays) {
    setCookie(value);
    (0, exports.setCookieItem)(key, JSON.stringify(value), numberOfDays);
  };

  return [cookie, updateCookie];
};

exports.useCookie = useCookie;